<ngx-simplebar class="responsiveScrollContainer"
  ><div
    class="energyToolContainer"
    [ngClass]="getGridClass()"
    *appHasPermission="{
      permissions: [
        permissions.allPermissions.ASSET_HIERARCHY_READ,
        permissions.allPermissions.ENERGY_TOOL_READ,
        permissions.allPermissions.ASSET_DYNAMIC_DATA_READ,
      ],
      needsAllPermissions: true,
    }"
  >
    <!-- [ngClass]="{ energyToolDisabled: dataSources.energyToolDisabled() }" -->
    <div class="energyToolHierarchy">
      <app-asset-hierarchy
        [preventTenantClick]="true"
        (assetClicked)="selectAsset($event)"
        [initialSelectedAssetId]="initialSelectedAssetId"
        [initialSelectedAssetType]="initialSelectedAssetType"
      ></app-asset-hierarchy>
    </div>
    <router-outlet style="display: none"></router-outlet>
  </div>
</ngx-simplebar>
